<style lang="scss" scoped>
.originator-btn {
  text-transform: none;
  font-weight: normal;
  font-size: 0.875rem;

  &.selected {
    font-weight: bold;
  }
}
</style>

<template>
  <div>
    <v-row>
      <v-col>
        <span class="black--text heading">
          Originators
        </span>
      </v-col>
    </v-row>
    <v-divider />
    <v-row>
      <v-col>
        <div v-for="originator in originators" :key="originator._id">
          <v-btn
            text
            small
            class="originator-btn"
            :color="value === originator ? 'primary' : null"
            :class="{ 'selected': value === originator }"
            :id="`groups-originator-btn-${originator._id}`"
            @click="() => $emit('input', originator)"
          >
            {{ originator.display_name }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import userMixin from '@/mixins/userMixin';


export default {
  name: 'AdminGroupsOriginators',
  mixins: [userMixin],
  props: {
    value: Object,
  },
  data: () => ({
    originators: [],
    loading: false,
  }),
  methods: {
    fetch() {
      this.loading = true;

      const params = {
        group: 'loans:account_executives',
        active_only: true,
      };
      this.$requests.get('/v1/users', { params })
        .then(response => {
          this.originators = this.resolveUsers(response.data);
        })
        .catch(() => {
          this.$toast.error('Unable to resolve originators list...', { timeout: 3000 });
        })
        .then(() => { this.loading = false; });
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
